export const config = {
  creatCol: [],
  updateCol: [],
};
